export function clearDependentFields(changedField, onValueChange) {
  switch (changedField) {
    case 'carMaker':
      onValueChange('modelLine', '');
      onValueChange('year', '');
      onValueChange('modification', '');
      onValueChange('oemUrl', '');
      break;
    case 'modelLine':
      onValueChange('year', '');
      onValueChange('modification', '');
      onValueChange('oemUrl', '');
      break;
    case 'year':
      onValueChange('modification', '');
      onValueChange('oemUrl', '');
      break;
    default:
      break;
  }
}
